export default "__VITE_ASSET__qF5E7F7F__"